import moment from 'moment';
import { styledDefaultColDef } from '../../../extras/cellRenderers';

export const columnDefs = (setCurrentJob, setIsOpen) => [
  {
    headerName: 'Id',
    field: 'jobId',
  },
  {
    headerName: 'Title',
    field: 'title',
    resizable: true,
    valueGetter: (props) => {
      return props?.data?.title;
    },
    cellRenderer: (params) => {
      return (
        <div
          className='flex items-center h-full cursor-pointer'
          onClick={() => {
            // history.push();
            setCurrentJob(params?.data);
            setIsOpen(true);
          }}
        >
          {params?.data?.title}
        </div>
      );
    },
  },
  {
    headerName: 'Company Name',
    field: 'companyName',
    resizable: true,
  },
  {
    headerName: 'Domain',
    field: 'domain',
    resizable: true,
  },
  {
    headerName: 'Employment Type',
    field: 'employmentType',
    resizable: true,
  },
  {
    headerName: 'Description',
    field: 'shortDescription',
    resizable: true,
  },
  {
    headerName: 'Location',
    field: 'location',
    resizable: true,
  },
  {
    headerName: 'Job Location',
    field: 'locationRequirement',
    resizable: true,
    hide: true,
  },
  {
    headerName: 'Min Salary',
    field: 'minSalary',
    resizable: true,
    hide: true,
  },
  {
    headerName: 'Max Salary',
    field: 'maxSalary',
    resizable: true,
    hide: true,
  },
  {
    headerName: 'Min Exp',
    field: 'minExperienceRequired',
    resizable: true,
    hide: true,
  },
  {
    headerName: 'Max Exp',
    field: 'maxExperienceRequired',
    resizable: true,
    hide: true,
  },
  {
    headerName: 'Posted At',
    field: 'postedAt',
    resizable: true,
    hide: true,
    cellRenderer: (params) => {
      return (
        <div className=''>
          {moment(params?.data?.postedAt).format('DD MMM YYYY')}
        </div>
      );
    },
  },
  {
    field: 'createdAt',
    hide: true,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
